import type { Dayjs } from 'dayjs'
import et from 'dayjs/locale/et'

interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...et,
  name: 'et',
  weekStart: 1,
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Jaan._Veebr._Märts_Apr._Mai_Juuni_Juuli_Aug._Sept._Okt._Nov._Dets.'.split('_')
    const standard = 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  }
}

export default locale
